import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'dialog-result-example-dialog',
  template: `<h1 md-dialog-title>Carregando</h1>
     <div md-dialog-content>{{ text }}</div>
    <div md-dialog-actions style='justify-content: center;'>
    <div>
    <md-progress-spinner style="height: 30px; width: 30px; margin:0 auto;" mode="indeterminate"></md-progress-spinner>
    </div>
    </div>`,
})
export class LoadingComponent {

  text = "";
  constructor(public dialogRef: MdDialogRef<LoadingComponent>) {
    this.text = dialogRef._containerInstance.dialogConfig.data;
  }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/component/loading.component.ts